import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION5: PdfComponent = {
  type: 'section',
  id: 's3s5',
  title: '5. Credit Application Value Limits',
  content: [
    {
      type: 'bulletList',
      id: 's3s5bullets',
      bulletType: 'dot',
      content: [
        {
          copy: {
            type: 'altText',
            id: 's3s5min',
            content: ['Minimum Loan Value', ': £100.00'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's3s5max',
            content: ['Maximum Loan Value', ': £50,000.00'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: 's3s5lv',
            content: [
              'Loan value',
              ' = total order price (including VAT) minus Customer deposit.',
            ],
          },
        },
      ],
    },
    {
      type: 'altText',
      id: 's3s5footer',
      content: [
        'Thus, the minimum product price eligible for finance is £100.00 (with 0% deposit), and the maximum is £100,000.00 (with a £50,000.00 deposit).',
      ],
      boldFirst: false,
    },
  ],
};
